import script from "./RemoteMeetings.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoteMeetings.vue?vue&type=script&setup=true&lang=ts"

import "./RemoteMeetings.vue?vue&type=style&index=0&id=5210d5e6&scoped=true&lang=css"
import "./RemoteMeetings.vue?vue&type=style&index=1&id=5210d5e6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5210d5e6"]])

export default __exports__